var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesnormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.232 7.41-.921.389.921-.39Zm0 1.18-.921-.39.921.39ZM2.863 7.798a5.669 5.669 0 0 1 5.224-3.466v-2A7.669 7.669 0 0 0 1.021 7.02l1.842.778Zm5.224-3.466a5.669 5.669 0 0 1 5.224 3.466l1.842-.778a7.669 7.669 0 0 0-7.066-4.688v2ZM13.311 8.2a5.669 5.669 0 0 1-5.224 3.466v2a7.669 7.669 0 0 0 7.066-4.688L13.311 8.2Zm-5.224 3.466A5.669 5.669 0 0 1 2.863 8.2l-1.842.778a7.669 7.669 0 0 0 7.066 4.688v-2ZM13.311 7.8a.517.517 0 0 1 0 .401l1.842.778a2.518 2.518 0 0 0 0-1.957l-1.842.778ZM1.02 7.02a2.518 2.518 0 0 0 0 1.957L2.863 8.2a.517.517 0 0 1 0-.401L1.021 7.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.087,
    cy: 8,
    r: 2,
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    transform: "translate(.087)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesnormal);
export default __webpack_public_path__ + "static/media/eyesnormal.a110ba0c9a6736eb779b77c033d6986e.svg";
export { ForwardRef as ReactComponent };